/* eslint-disable @typescript-eslint/no-namespace */
import { BaseControlBehaviour } from '../BaseControlBehaviour';
/**
 * UseBettingCartBehaviour - добавляет функционал добавление коэфа в корзину
 */
export class UseBettingCartBehaviour extends BaseControlBehaviour {
    constructor() {
        super('use-betting-cart');
    }

    protected installBehaviour(element: HTMLElement): void {
        const jel: JQuery = $(element);
        const coefProp: string = this.getBehaviorValue(element);
        const coefTitle: string = jel.attr(this.tag + '-title');
        const event: any = jel.data('event');

        const data: BettingCartItem = {
            oId: event[coefProp].OriginalId,
            aId:
                event[coefProp].ActualId == 0 ||
                event[coefProp].ActualId == null
                    ? event[coefProp].OriginalId
                    : event[coefProp].ActualId,
            eId: event.EventId,
            eTitle: event.EventName,
            rTitle: coefTitle,
            val: event[coefProp].Value,
            isLive: event.IsLive,
        };

        function removeFromCart(oId) {
            return window.ClientCart.removeOutcome(Number(oId));
        }

        function addToCart(sData) {
            return window.ClientCart.addOutcome({
                oId: Number(sData.oId),
                eId: Number(sData.eId),
            });
        }

        function isInCart(oId) {
            return window.ClientCart.hasOutcome(Number(oId));
        }

        jel.click(() => {
            if (isInCart(data.oId)) {
                removeFromCart(data.oId);
                jel.removeClass('active');
            } else {
                addToCart(data).then((added) => {
                    if (added) {
                        jel.addClass('active');
                        BettingCart.Highlighting.activate.table();
                    }
                });
            }
        });

        if (isInCart(data.oId)) jel.addClass('active');

        $(document).on('deactivateCoefHightlight', (e, oid) => {
            if (data.oId == oid) jel.removeClass('active');
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.UseBettingCartBehaviour = UseBettingCartBehaviour;